import React from 'react';
import Header from './components/Header';
import * as Images from '../assets';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
} from '@mui/material';
import { LightBlueButton } from '../components';
import { MailOutline, PlaceOutlined } from '@mui/icons-material';
import Map from './components/Map';
import { countryList } from '../constants/constants';

const ContactPage = () => {
  return (
    <div>
      {/* <Header page="contact" /> */}
      <div
        className="md:px-8 px-2 md:py-16 py-8 flex justify-center"
        style={{
          backgroundImage: `url('${Images.homePage8}')`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          transition:
            'background 0.3s, border 0.3s, border-radius 0.3s, box-shadow 0.3s',
        }}
      >
        <div className="lg:w-[80%] md:w-[85%] sm:w-[95%] w-[100%] ">
          <Grid
            container
            spacing={6}
            className="lg:px-12 md:px-8 px-6 flex justify-center"
          >
            <Grid item md={6} xs={12}>
              <div className="flex flex-col gap-4 text-md h-full">
                <Map />
              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div className="flex flex-col gap-4 text-md">
                <div className="flex flex-col gap-6">
                  <div className="text-3xl font-bold">
                    Wanna get in contact?
                  </div>
                  <div>
                    Get in touch to discover how Aid-LINK can help you and your
                    company optimise the efficiency of Tender Alert Service and
                    Supplier Directory.
                  </div>
                  <div>
                    Please complete the form and we will connect with you as
                    soon as possible.
                  </div>
                  <div className=" flex flex-col gap-2">
                    <div className="hover:text-[var(--dark-blue)] text-xs flex items-center gap-1">
                      <div>
                        <PlaceOutlined fontSize="small" />
                      </div>
                      <div className="text-sm">
                        Stensballegaardvej 23 <br /> 8700 Horsens, Denmark
                      </div>
                    </div>
                  </div>
                </div>

                <TextField
                  size=""
                  className="bg-white"
                  required
                  label="First Name"
                />
                <TextField
                  size=""
                  className="bg-white"
                  required
                  label="Last Name"
                />
                <TextField
                  size=""
                  className="bg-white"
                  required
                  label="Job Title"
                />
                <TextField
                  size=""
                  className="bg-white"
                  required
                  label="Company"
                />
                <TextField
                  size=""
                  className="bg-white"
                  required
                  label="Country"
                  select
                >
                  <MenuItem value="">
                    <em>Select</em>
                  </MenuItem>
                  {countryList.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  size=""
                  className="bg-white"
                  required
                  label="Work Email"
                />
                <TextField size="" className="bg-white" label="Phone number" />
                <TextField
                  size=""
                  className="bg-white"
                  required
                  label="Subject"
                />

                <TextField
                  size=""
                  className="bg-white"
                  label="Type your message here..."
                  required
                  multiline
                  minRows={3}
                />
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Yes, please keep me updated with Aid-LINK’s product news. I can unsubscribe at any time."
                />

                <div className="text-sm text-gray-500">
                  By submitting this form, you agree that Aid-LINK may contact
                  you in order to respond to your request. Your personal data
                  will be processed in accordance with Aid-LINK’s privacy
                  policy.
                </div>

                <LightBlueButton size="large">SEND</LightBlueButton>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="text-center">
                Aid-LINK Ltd., Stensballegaardvej 23, 8700 Horsens, Denmark
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
